import type { Lucid } from '../../types/types';

export const getStatGridFontSize = (
  shortCode: Lucid.I18n.LanguagesShortCode,
  fontSizeConfig: {
    small: number;
    medium: number;
    large: number;
    default: number;
  },
) => {
  switch (shortCode) {
    case 'nl':
    case 'da':
      return fontSizeConfig.small;
    case 'ja':
    case 'de':
    case 'pt':
    case 'sv':
      return fontSizeConfig.medium;
    case 'ru':
    case 'it':
    case 'ko':
    case 'pl':
    case 'es':
      return fontSizeConfig.large;
    default:
      return fontSizeConfig.default;
  }
};
